import React, { useCallback, useState } from "react";
import Breadcrumbs from "components/common/Breadcrumbs";
import styles from "./Panier.module.css";
import archiveStyle from "styles/modules/Archives.module.css";
import PanierSummary from "components/common/PanierSummary";
import PanierAuth from "components/common/PanierAuth";
import AddresseManager from "components/common/AddresseManager";
import { useAuth } from "contexts/AuthContext";
import { setAddressToCart, startPayment } from "services/api";
import { useCart } from "contexts/CartContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Spinner from "components/common/Spinner";
import { Helmet } from "react-helmet";



const OrderFinalization = () => {

  const [selectedAddressId, setSelectedAddressId] = useState(null);
  const [CGVAccepted, setCGVAccepted] = useState(false);

  const { isLoggedIn } = useAuth();
  const { cartQuantity, relaodCart, loadingCart } = useCart();

  const navigate = useNavigate();

  useEffect(() => {
    if (cartQuantity === 0 && !loadingCart) {
      navigate("/panier", { replace: true });
    }
  }, [cartQuantity, loadingCart]);


  const handleSelectAddress = useCallback(() => {
    console.log("🚀 DEBUG: Bouton Poursuivre l'achat cliqué", {
      selectedAddressId,
      CGVAccepted
    });

    setAddressToCart({ addressId: selectedAddressId })
      .then((response) => {
        console.log("✅ DEBUG: Réponse setAddressToCart", response);
        
        if (response.success) {
          console.log("🎯 DEBUG: Adresse validée, démarrage du paiement...");
          
          return startPayment();
        } else {
          console.error("❌ DEBUG: Échec setAddressToCart", response);
          throw new Error("Échec de l'ajout d'adresse");
        }
      })
      .then((paymentResponse) => {
        console.log("💳 DEBUG: Réponse startPayment COMPLÈTE", paymentResponse);
        console.log("💳 DEBUG: paymentResponse.data DÉTAILLÉ", paymentResponse.data);
        console.log("💳 DEBUG: Type de paymentResponse.data", typeof paymentResponse.data);
        console.log("💳 DEBUG: Clés disponibles dans data", Object.keys(paymentResponse.data || {}));
        
        if (paymentResponse && paymentResponse.data && paymentResponse.data.url && paymentResponse.data.url.trim() !== '') {
          console.log("🌐 DEBUG: Redirection vers", paymentResponse.data.url);
          window.location.href = paymentResponse.data.url;
        } else {
          console.error("❌ DEBUG: URL de paiement vide ou manquante", paymentResponse);
          console.error("❌ DEBUG: URL reçue:", `"${paymentResponse.data?.url}"`);
          alert("Erreur: Le backend a retourné une URL de paiement vide. Problème côté serveur à résoudre.");
        }
      })
      .catch((error) => {
        console.error("💥 DEBUG: Erreur dans handleSelectAddress", error);
        alert("Erreur lors du démarrage du paiement: " + error.message);
      });
  }, [selectedAddressId]);

  if (loadingCart) {
    return <Spinner />;
  }

  return (
    <>
      <Helmet>
        <title>Finaliser votre commande - Pharos</title>
        <meta name="description" content="Finalisez votre commande en sélectionnant une adresse de livraison et en acceptant les conditions générales de vente." />
        <meta property="og:title" content="Finaliser votre commande - Pharos" />
        <meta property="og:description" content="Finalisez votre commande en sélectionnant une adresse de livraison et en acceptant les conditions générales de vente." />
        <meta property="og:type" content="website" />
      </Helmet>
      <div className={`page-content section-no-padding ${styles.pageContent}`}>
        <section className={`global-section global-section-title ${styles.section}`}>
          <div className={`global-container ${styles.content}`}>
            <div className={archiveStyle.header}>
              <h1 className="h2">Finaliser votre commande</h1>
              <Breadcrumbs
                pageType={'isOrder'}
                element={{ title: "Finaliser votre commande" }}
              />
            </div>
          </div>
        </section>
        <section className={`global-section ${styles.section}`}>
          <div className={`global-container ${styles.content}`}>
            <div className={styles.FinalizeOrder}>
              {!isLoggedIn ? <PanierAuth /> :
                <AddresseManager tunnel onSelectAddress={(id) => {
                  setSelectedAddressId(id)
                }}
                  onAcceptConditions={(accepted) => {
                    setCGVAccepted(accepted);
                  }}
                />}
              <PanierSummary addressId={selectedAddressId} CGVAccepted={CGVAccepted} onSubmit={handleSelectAddress} />
            </div>
          </div>
        </section>
      </div >
    </>
  );
};

export default OrderFinalization;
